module.exports = __webpack_public_path__ + "assets/img/jewelryBoxBg.1f5823b0.png";